// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__copVk","home":"styles_home__QWxgR"};